
// |--------------------------------------------------------------------------
// | DATA ANALYSER UTILITY FUNCTIONS
// |--------------------------------------------------------------------------

import login from '@/login'
import moment from 'moment'

export function setupPermissionIds (indexBy, groupBy, id) {
  let idsArr = [{prop: indexBy, value: id}]

  if (login.can('analytics.channel')
    && !login.can('analytics.network')
    && (['account', 'user'].includes(indexBy) || (indexBy === 'network' && ['account', 'user'].includes(groupBy)))
  ) {
    const userChannel = login.getChannel()
    if (userChannel !== null && userChannel !== undefined) {
      if (indexBy === 'network' && ['account', 'user'].includes(groupBy)) {
        idsArr = [{prop: 'channel', value: userChannel.id}]
      } else {
        idsArr = [{prop: 'channel', value: userChannel.id}, {prop: indexBy, value: id}]
      }
    } else {
      console.error('Channel ID required to load channel wide analytics')
      return null
    }
  }

  return idsArr
}

export function percDiff(val, lastVal, str = false, timeframe = undefined) {
  if (val === 0 || lastVal === 0) {
    if (str) {
      return ''
    } else {
      return false
    }
  } else {

    if (timeframe.includes("days")) {
      const hourOfTheDay = parseInt(moment().format("HH"))
      const dayPercentageRemaining =  1 - (Math.max(1, hourOfTheDay)/24)
      const numberDays = parseInt(timeframe.split("_")[1])

      val = val * numberDays / (numberDays - dayPercentageRemaining)
    }

    else if (timeframe.includes("weeks")) {
      const hourOfTheDay = parseInt(moment().format("HH"))
      const dayOfTheWeek = parseInt(moment().day()) + (Math.max(1, hourOfTheDay) / 24)

      const weekPercentageRemaining = 1 - (dayOfTheWeek/7)
      const numberWeeks = parseInt(timeframe.split("_")[1])

      val = val * numberWeeks / (numberWeeks - weekPercentageRemaining)
    }

    const diff = Math.round(((val - lastVal) / lastVal) * 100)
    if (str) {
      return `${diff > -1 ? '+' : ''}${diff}%`
    } else {
      return diff
    }
  }
}

export function calcEngagement (dataArr, timeChunk, mins = true) {
  let result = 0
  for (const data of dataArr) {
    console.log(data[timeChunk])
    result += sum(data[timeChunk].map((inter) => inter.value.sum_read_seconds ))
  }

  return Math.ceil(result / (mins ? 60 : 1))
}

export function getCountEvents (events, attr = 'count_events', groupByAttr = null, groupByVal = null) {
  return events !== undefined && events !== null
    ? events.map((event) => getCountEvent(event, attr, groupByAttr, groupByVal))
    : []
}

export function getCountEvent (event, attr = 'count_events', groupByAttr = null, groupByVal = null) {
  if (groupByAttr !== null && groupByVal !== null) {
    const groupArr = event.value.filter((v) => v[`custom_attributes.${groupByAttr}`] === groupByVal)
    return groupArr && groupArr.length > 0
       ? groupArr[0][attr]
       : 0
  } else {
    return event.value[attr]
  }
}

export const sumCountEvents = (events) => sum(getCountEvents(events))
export const sumCountEventsUniqueUser = (events) => sum(events.map((chunk) => {
  console.log(chunk, chunk.value)
  return chunk.value.count_events_unique_user || chunk.value.count_events_unique_article || 0
}))
export const sumCountEventsGrouped = (events, groupByAttr, groupByVal, attr = 'count_events') => sum(getCountEvents(events, attr, groupByAttr, groupByVal))

export const calcAvgType = (events, type = 'article', groupByAttr = null, groupByVal = null) => {
  const sumCountEvents = sum(getCountEvents(events, 'count_events', groupByAttr, groupByVal))
  const sumCountEventsunique = sum(getCountEvents(events, `count_events_unique_${type}`, groupByAttr, groupByVal))

  return sumCountEventsunique > 0 ? Math.round(sumCountEvents / sumCountEventsunique) : 0
}

export const calcAvgSingle = (event, type, groupByAttr = null, groupByVal = null) => {
  const uniqUserCount = getCountEvent(event, `count_events_unique_${type}`, groupByAttr, groupByVal)

  return uniqUserCount > 1
    ? Math.round(getCountEvent(event, 'count_events', groupByAttr, groupByVal) / uniqUserCount)
    : 0
}

export const calcAvgPerc = (arr) => {
  return Math.round(
      average(
          arr
              .map((interval) => interval.value.avg_max_scroll_depth)
              .filter(largerZero)
      ) * 100
  )
}

export const calcAvgReadTime = (obj1, obj2, timeChunk) => {
  return Math.round(calcEngagement([obj1, obj2], timeChunk, false) / (sumCountEvents(obj1?.[timeChunk] || []) + sumCountEvents(obj2?.[timeChunk] || [])))
}

export const average = (arr) => (arr.length > 0 ? arr.reduce((p, c) => p + c, 0) / arr.length : 0)
export const sum = (arr) => (arr.length > 0 ? arr.reduce((p, c) => p + c, 0) : 0)
export const largerZero = (val) => val && val > 0
export const capitalise = (str) => str.charAt(0).toUpperCase() + str.slice(1)
export const capMult = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) {
      return ''
    } // or if (/\s+/.test(match)) for white spaces
    return match.toUpperCase()
  })
}

export const sortDesc = (arr) => {
  if (arr.length > 0) {
    const sortDownloaded = 'webDownloads' in arr[0]
    const sortEmailViews = 'emailViews' in arr[0]
    const sortSendgridOpened = 'sendgridOpened' in arr[0]

    arr.sort((a, b) => {
      return b.value - a.value || (sortDownloaded ? b.webDownloads - a.webDownloads : true) || (sortEmailViews ? b.emailViews - a.emailViews : true) || (sortSendgridOpened ? b.sendgridOpened - a.sendgridOpened : true)
    })
  }

  return arr
}
